import { get, keyBy } from 'lodash'
import {
  FETCH_SALES_EVENTS_REQUESTED,
  FETCH_SALES_EVENTS_SUCCEEDED,
  FETCH_SALES_EVENTS_FAILED,
  FETCH_SALES_EVENT_TYPES_SUCCEEDED,
  FETCH_SALES_EVENT_TYPES_FAILED,
  SET_ACTIVE_EVENT_ID,
  FETCH_SALES_EVENT_TYPES_REQUESTED,
} from '../../actions/suites/salesEvent'

const defaultState = {
  activeEventId: null,
  byId: {},
  eventTypes: {
    byId: {},
    requestFailed: false,
  },
  requestFailed: false,
}

const reducer = (state = defaultState, action) => {
  switch(action.type) {
    case FETCH_SALES_EVENTS_REQUESTED:
      return {
        ...state,
        requestLoading: true,
        requestSucceeded: false,
        requestFailed: false,
      }

    case FETCH_SALES_EVENTS_SUCCEEDED: {
      const salesEvents = get(action.payload, 'data.salesEvents', [])
      const byId = keyBy(salesEvents, 'uuid')

      return {
        ...state,
        byId: byId,
        requestLoading: false,
        requestSucceeded: true,
        requestFailed: false,
      }
    }

    case FETCH_SALES_EVENTS_FAILED: {
      return {
        ...state,
        requestLoading: false,
        requestSucceeded: false,
        requestFailed: true,
      }
    }

    case FETCH_SALES_EVENT_TYPES_REQUESTED:
      return {
        ...state,
        eventTypes: {
          ...state.eventTypes,
          requestLoading: true,
          requestSucceeded: false,
          requestFailed: false,
        }
      }

    case FETCH_SALES_EVENT_TYPES_SUCCEEDED: {
      const eventTypes = get(action.payload, 'data.salesEventTypes', [])
      const byId = keyBy(eventTypes, 'uuid')

      return {
        ...state,
        eventTypes: {
          byId: byId,
          requestLoading: false,
          requestSucceeded: true,
          requestFailed: false,
        }
      }
    }

    case FETCH_SALES_EVENT_TYPES_FAILED: {
      return {
        ...state,
        eventTypes: {
          ...state.eventTypes,
          requestLoading: false,
          requestSucceeded: false,
          requestFailed: true,
        },
      }
    }

    case SET_ACTIVE_EVENT_ID: {
      return {
        ...state,
        activeEventId: get(action, 'payload.eventId')
      }
    }

    default:
      return state

  }
}

export default reducer
